import { render, staticRenderFns } from "./ProductDescriptionsCompare.vue?vue&type=template&id=6596ac79&scoped=true"
import script from "./ProductDescriptionsCompare.vue?vue&type=script&lang=js"
export * from "./ProductDescriptionsCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6596ac79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6596ac79')) {
      api.createRecord('6596ac79', component.options)
    } else {
      api.reload('6596ac79', component.options)
    }
    module.hot.accept("./ProductDescriptionsCompare.vue?vue&type=template&id=6596ac79&scoped=true", function () {
      api.rerender('6596ac79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/ProductDescriptionsCompare.vue"
export default component.exports